module.exports = __webpack_public_path__ + "img/202505_03.dd35c43d.jpg";